import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DispatcherHomeService } from './dispatcherhome.service';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MissionService } from '../../app.constant';
import { Router } from '@angular/router';
import * as myGlobals from '../../globals';
import { LanguageService } from '../../language.service';
import { ConfigService } from '../../config.service';
import { MqttService } from '../../mqtt.service';
import { Observable } from 'rxjs/Observable';
import { Paho } from 'ng2-mqtt/mqttws31';
import { DispatcherService } from '../dispatcher.service';

declare const jQuery: any;
declare var google: any;
declare var $: any;
declare var flatpickr: any;
declare var moment: any;
declare var swal: any;
declare var toastr: any;

//  var mapboxgl = require('mapbox-gl');

@Component({
  selector: 'dispatcherhome',
  templateUrl: './dispatcherhome.component.html',
  styleUrls: ['./dispatcherhome.component.css', './../dispatcher.component.css']
})
export class DispatcherHomeComponent implements OnInit {
  @Input()
  private client: Paho.MQTT.Client;
  online$: Observable<boolean>;

  assigned = [];
  unassigned = [];
  past = [];
  showdropaddress = true;
  errmessage: any;
  errMsg: any;
  mqtt: any;
  mqttId: any;

  disphome: any;
  jobdetails: any;
  invoice: any;
  cancelbooking: any;

  fp_incr: any;
  pickuplat;
  pickuplong;
  droplat;
  droplong;
  driverlat;
  driverlong;
  photo;
  vechiletypes: any;
  approx: any;
  vehicle_device_id: any;
  info;
  Path;
  zpath: any;
  data: any;
  data1 = [];
  data2 = [];
  data3 = [];
  getdata;
  own_lat_long: any;
  own_later_date;
  rec_name: any;
  rec_number: any;
  rec_mail: any;
  rec_lat_long: any;
  product_det: any;
  product_qty: any;
  product_wgt: any;
  vechicle_type: any;
  passDetailsContent: any;
  dynamic_latlong: any;
  file: any;
  fname_b: any;
  map: any;
  marker: any;
  style: any;
  fmail_b: any;
  // pubnub:any;
  current_time: any;
  current_time_var: any;
  public form: FormGroup;
  public phoneNumber: AbstractControl;
  public password: AbstractControl;
  public submitted: boolean = false;
  assigned_count: any = 0;
  assigned_full_count: any = 0;
  completed_count: any = 0;
  mapr: any;
  page_index: any = 0;
  route_map_lt;
  route_map_lng;
  route_map_driver_lat;
  route_map_driver_lng;
  directions: any;
  polyline: any;
  // GODS VIEW MARKERS VARIABLES
  drivers_list = [];
  markers_number: number = 0;
  drivers_layer: any;
  drivers_lat_long = [];
  overlayMaps: any;
  route_markers = [];
  driver_lat_route: any;
  driver_lng_route: any;
  driver_markers_inst: any;
  drivers_timings = [];
  driver_timing_singal: any;
  driver_online_offline: any;
  driver_online_email: any;
  difference_of_timings: any;
  picker_date: any;
  drop_date: any;
  picker_bool: boolean = false;
  server_time: any;
  first_render: number = 0;
  fphone_b: any;
  online_drivers = [];
  offline_drivers = [];
  total_drivers = [];
  ent_lati = "19.6008014678955";
  ent_long = "-99.2285003662109";
  driver_latlong_change: any;
  map1: any;
  allroute_markers = [];
  directionsDisplay: any;
  myname: any;
  myphn: any;
  mymail: any;
  changing_location_data = [];
  changing_location_status: any;
  current_driver_marker: any;
  path_his = [];
  current_location_marker: any;
  current_driver = {
    "Device_type_": "",
    "a": "",
    "app_version": "",
    "battery_Per": "",
    "bid": "",
    "lg": "",
    "lt": "",
    "location_check": "",
    "st": "",
  };
  allpath_markers = [];
  show_drivers = false;
  cancellation_bid: any;
  cancel_reasons = [];
  currency: any;
  pathline: any;
  onLoadLatitude: any;
  onLoadLongitude: any;
  /** CANCEL BOOKING VARIABLES*/
  cancellation_fee: any;
  cancellation_reason: any;

  dropDetails: Boolean = false;
  timeline: Boolean = false;
  fee: any;
  callFrom: any;

  driverMarker: any;
  pickupMarker: any;
  dropMarker: any;
  vehicle_icon: any;
  driver_marker_loc: any;
  pickup_marker_loc: any;
  drop_marker_loc: any;
  markers = [];

  // search by date
  type = 1;
  limit = 10;
  skip = 0;
  status = '';
  fromDate = '';
  toDate = '';
  bookingSearch = '';
  bookings: any;
  totcount: any;
  liveStatus: any;

  id: any;
  i: any;
  notMinFee: any;
  journey_time: any;
  mappickup_drop_bounds: any;
  mqttarray = [];
  flightPath = [];
  map_marker = [];
  markerdata: any;
  mqttTransit
  mqttStatus: any;
  mqttlat: any;
  mqttlong: any;
  mqttlatlong: any = [];
  showing_balance: any;
  walletEnable: any;

  pending_review = [];
  rating_b_details = [];
  driver_rating = [];
  rating_text = [];
  show_select = false;
  show_high_rating = false;
  show_low_rating = false;
  rating_num: any;
  rating_error = false;
  comment_error = false;
  show_highrate_comment = false;
  high_rating = [];
  bookcomplete = {};
  dropchangeMarker: any;
  changeDroplat: any;
  changeDroplong: any;
  changeAddress: any;
  adddrop: any;
  driverId: any;
  removeFav: Boolean = false;
  favDiverId: any;
  pendingBookingId: any;
  pendingDriverId: any;
  rating = 0;
  comments: any;
  singleId: any;
  singleStatus: any;
  bookingid: any;
  tips: any;
  cardDeduct: any;
  tipEnable: Boolean = false;
  tipType: any;
  tipValues: any;
  driverVehicleShow = true;
  invoice_link = myGlobals.invoice_admin;
  information: any;

  constructor(
    private _cookie: ConfigService,
    private _dispatcherHomeService: DispatcherHomeService,
    fb: FormBuilder, private _router: Router,
    private _missionService: MissionService,
    private languageService: LanguageService,
    private _mqttService: MqttService,
    private _dispatcherService: DispatcherService) {

    this.online$ = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').mapTo(true),
      Observable.fromEvent(window, 'offline').mapTo(false)
    )
    // mqtt for changing status
    _mqttService.missionAnnounced$.subscribe((data: any) => {
      switch (data.status) {
        case 6: // Driver on the way
          this.driverOnWay(data);
          break;
        case 7: // Driver Arrived
          this.driverArrived(data);
          break;
        case 8: // Loading start (shipment only)
          this.loadingStart(data);
          break;
        case 9: // Journey started
          this.journeyStart(data);
          break;
        case 10:  // Reached to Drop start unloading(shipment Only)
          this.reachedDrop(data);
          break;
        case 11:  // unloaded(shipment Only)
          this.unloaded(data);
          break;
        case 2: // accepted Booking
          this.acceptBooking(data);
          break;
        case 3: // cancel boking before accept by customer
          this.cancelBefore(data);
          break;
        case 4: // cancel boking after accept by customer
          this.cancelAfter(data);
          break;
        case 5: // cancel boking by driver
          this.cancelByDriver(data);
          break;
        case 13:  // booking expired
          this.bookingExpired(data);
          break;
        case 12:  // Completed
          this.completed(data);
          break;
      }
    });

    _missionService.missionAnnounced$.subscribe(
      (data: any) => {
        if (this.changing_location_data.length == 0) {
          this.changing_location_data.push(data);
          this.changindriver_loc(data);
        }
        else {
          for (var inst = 0; inst < this.changing_location_data.length; inst++) {
            if (this.changing_location_data[inst].bid == data.bid) {
              this.changing_location_data.splice(inst, 1);
              this.changing_location_data.splice(0, 0, data);
              this.changindriver_loc(data);
              break;
            }
            else if (inst == this.changing_location_data.length - 1) {
              if (this.changing_location_data[inst].bid != data.bid) {
                this.changing_location_data.push(data);
                this.changindriver_loc(data);
                break;
              }
              else {
                this.changing_location_data.splice(inst, 1);
                this.changing_location_data.splice(0, 0, data);
                this.changindriver_loc(data);
                break;
              }
            }

            if (this.current_driver.bid == this.changing_location_data[inst].bid) {
              this.current_driver.Device_type_ = this.changing_location_data[inst].Device_type_;
              this.current_driver.a = this.changing_location_data[inst].a;
              this.current_driver.app_version = this.changing_location_data[inst].app_version;
              this.current_driver.battery_Per = this.changing_location_data[inst].battery_Per;
              this.current_driver.lg = this.changing_location_data[inst].lg;
              this.current_driver.lt = this.changing_location_data[inst].lt;
              this.current_driver.location_check = this.changing_location_data[inst].location_check;
              this.current_driver.st = this.changing_location_data[inst].st;
            }
          }
        }
      }
    );
    this.form = fb.group({
      'phoneNumber': ['', Validators.compose([Validators.required])],
      'password': ['', Validators.compose([Validators.required, Validators.minLength(4)])]
    });

    this.phoneNumber = this.form.controls['phoneNumber'];
    this.password = this.form.controls['password'];
  }
  // driver mqtt
  mqttsubscribe(driver) {
    this.client = new Paho.MQTT.Client(myGlobals.mqtt_channel, "myClientId" + new Date().getTime());
    this.client.onConnectionLost = (responseObject: Object) => {
    };
    this.client.onMessageArrived = (message: Paho.MQTT.Message) => {
      const response = JSON.parse(message.payloadString);
      this.mqttStatus = response.driverId;
      this.mqttlat = JSON.parse(message.payloadString).latitude;
      this.mqttlong = JSON.parse(message.payloadString).longitude;
      if (response.driverId == this.driver_marker_loc.id) {
        this.drawroute();
      }
      this.changeDriverMarkerLocation(JSON.parse(message.payloadString));
    };
    const options = {
      userName: 'uberforall',
      password: 'uberforall',
      useSSL: true,
      timeout: 60,
      keepAliveInterval: 15,
      // Gets Called if the connection has successfully been established
      onSuccess: () => {
        console.log('connected');
        this.client.subscribe(driver, { qos: 2 });
        // this.client.subscribe('godsview/location', { qos: 2 });
      },
      // Gets Called if the connection could not be established
      onFailure: function (message) {
        alert("failure");
        console.log('Connection failed:.' + message.errorMessage);
      }
    };
    this.client.connect(options);
  }

  public onSubmitLogin(values: Object): void {
    this.submitted = true;
    if (this.form.valid) {
      // your code goes here
    }
  }

  changeDriverMarkerLocation(data) {
    const lat = data.latitude;
    const long = data.longitude;
    const myLatlng = new google.maps.LatLng(lat, long);
    this.driver_marker_loc.setPosition(myLatlng);
    var latlngList = [];
    latlngList.push(new google.maps.LatLng(lat, long));

    var bounds = new google.maps.LatLngBounds();
    bounds.extend(myLatlng);
    this.map1.setCenter(bounds.getCenter()); //or use custom center
    this.map1.setZoom(17);
  }
  driverOnWay(data) {
    $('#booking_loader_parent').hide();
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.assigned.splice(0, 0, booking);
    } else {
      const index1 = this.unassigned.findIndex(array => array.bookingId === data.bookingId);
      if (index1 != -1) {
        this.unassigned[index1].status = data.status;
        this.unassigned[index1].statusText = data.statusText;
        const booking = this.unassigned[index1];
        this.assigned_full_count = this.assigned_full_count - 1;
        this.unassigned.splice(index1, 1);
        this.assigned.splice(0, 0, booking);
      } else {
        this.singleBooking(data.bookingId, data.status);
      }
    }
  }
  driverArrived(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.assigned.splice(0, 0, booking);
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.arrived != 0 || this.passDetailsContent.dateAndTime.arrived != undefined) {
          this.passDetailsContent.dateAndTime.arrived = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
    } else {
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.arrived != 0 || this.passDetailsContent.dateAndTime.arrived != undefined) {
          this.passDetailsContent.dateAndTime.arrived = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
      this.singleBooking(data.bookingId, data.status);
    }
  }
  loadingStart(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.assigned.splice(0, 0, booking);
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.loaded != 0 || this.passDetailsContent.dateAndTime.loaded != undefined) {
          this.passDetailsContent.dateAndTime.loaded = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
    }
  }
  journeyStart(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.assigned.splice(0, 0, booking);
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.journeyStart != 0 || this.passDetailsContent.dateAndTime.journeyStart != undefined) {
          this.passDetailsContent.dateAndTime.journeyStart = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
    }
  }
  reachedDrop(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.assigned.splice(0, 0, booking);
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.reachedDrop != 0 || this.passDetailsContent.dateAndTime.reachedDrop != undefined) {
          this.passDetailsContent.dateAndTime.reachedDrop = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
    }
  }
  unloaded(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.assigned.splice(0, 0, booking);
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.unloaded != 0 || this.passDetailsContent.dateAndTime.unloaded != undefined) {
          this.passDetailsContent.dateAndTime.unloaded = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
    }
  }
  acceptBooking(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.assigned.splice(0, 0, booking);
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.accepted != 0 || this.passDetailsContent.dateAndTime.accepted != undefined) {
          this.passDetailsContent.dateAndTime.accepted = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
    }
  }
  cancelBefore(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.completed_count = this.completed_count + 1;
      this.past.splice(0, 0, booking);
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.cancelled != 0 || this.passDetailsContent.dateAndTime.cancelled != undefined) {
          this.passDetailsContent.dateAndTime.cancelled = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
    }
  }
  cancelAfter(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.completed_count = this.completed_count + 1;
      this.past.splice(0, 0, booking);
      this.wallet();
      this.clearallpassdetails();
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.cancelled != 0 || this.passDetailsContent.dateAndTime.cancelled != undefined) {
          this.passDetailsContent.dateAndTime.cancelled = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
      this.passDetailsContent = '';
      if (this.allroute_markers.length > 0) {
        for (let inst = 0; inst < this.allroute_markers.length; inst++) {
          this.allroute_markers[inst].setMap(null);
        }
        this.allroute_markers = [];
      }
      if (this.markers.length > 0) {
        for (let inst = 0; inst < this.markers.length; inst++) {
          this.markers[inst].setMap(null);
          this.directionsDisplay.setMap(null);
        }
      }
      if (this.path_his.length > 0) {
        for (var inst = 0; inst < this.path_his.length; inst++) {
          this.path_his[inst].setMap(null);
          this.pathline.setMap(null);
        }
        this.path_his = [];
        this.markers = [];
      }
      if (this.mqttarray.length != 0) {
        for (let inst = 0; inst < this.map_marker.length; inst++) {
          this.map_marker[inst].setMap(null);
        }
        for (let inst = 0; inst < this.flightPath.length; inst++) {
          this.flightPath[inst].setMap(null);
        }
        this.map_marker = [];
      }
    }
  }
  cancelByDriver(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = "Driver Cancelled";
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.completed_count = this.completed_count + 1;
      this.past.splice(0, 0, booking);
      this.wallet();
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.cancelled != 0 || this.passDetailsContent.dateAndTime.cancelled != undefined) {
          this.passDetailsContent.dateAndTime.cancelled = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
      this.passDetailsContent = '';
      if (this.allroute_markers.length > 0) {
        for (let inst = 0; inst < this.allroute_markers.length; inst++) {
          this.allroute_markers[inst].setMap(null);
        }
        this.allroute_markers = [];
      }
      if (this.markers.length > 0) {
        for (let inst = 0; inst < this.markers.length; inst++) {
          this.markers[inst].setMap(null);
          this.directionsDisplay.setMap(null);
        }
      }
      if (this.path_his.length > 0) {
        for (var inst = 0; inst < this.path_his.length; inst++) {
          this.path_his[inst].setMap(null);
          this.pathline.setMap(null);
        }
        this.path_his = [];
        this.markers = [];
      }
      if (this.mqttarray.length != 0) {
        for (let inst = 0; inst < this.map_marker.length; inst++) {
          this.map_marker[inst].setMap(null);
        }
        for (let inst = 0; inst < this.flightPath.length; inst++) {
          this.flightPath[inst].setMap(null);
        }
        this.map_marker = [];
      }
    }
  }
  bookingExpired(data) {
    const index = this.assigned.findIndex(array => array.bookingId === data.bid);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = "Booking Expired";
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.completed_count = this.completed_count + 1;
      this.past.splice(0, 0, booking);
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.expired != 0 || this.passDetailsContent.dateAndTime.expired != undefined) {
          this.passDetailsContent.dateAndTime.expired = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
    } else {
      const index1 = this.unassigned.findIndex(array => array.bookingId === data.bid);
      if (index1 != -1) {
        this.unassigned[index1].status = data.status;
        this.unassigned[index1].statusText = "Booking Expired";
        const booking = this.unassigned[index1];
        this.unassigned.splice(index1, 1);
        this.assigned_full_count = this.assigned_full_count - 1;
        this.completed_count = this.completed_count + 1;
        this.past.splice(0, 0, booking);
        if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
          if (this.passDetailsContent.dateAndTime.expired != 0 || this.passDetailsContent.dateAndTime.expired != undefined) {
            this.passDetailsContent.dateAndTime.expired = moment().format("MMMM Do YYYY, h:mm:ss a");
          }
        }
      }
    }
  }
  completed(data) {
    this.getCustomerBookings(data.bookingId, data.status, 1);
    const index = this.assigned.findIndex(array => array.bookingId === data.bookingId);
    if (index != -1) {
      this.assigned[index].status = data.status;
      this.assigned[index].statusText = data.statusText;
      const booking = this.assigned[index];
      this.assigned.splice(index, 1);
      this.completed_count = this.completed_count + 1;
      this.past.splice(0, 0, booking);
      if ($('.right-window').hasClass('open')) {
        $(".right_marker span").trigger('click');
      }
      this.getAllBooking(3);
      this.wallet();
      this.pending_reviews();
      this.clearAllMarkers();
      this.clearallpassdetails();
      if (this.passDetailsContent != undefined && this.passDetailsContent != '') {
        if (this.passDetailsContent.dateAndTime.unloaded != 0 || this.passDetailsContent.dateAndTime.unloaded != undefined) {
          this.passDetailsContent.dateAndTime.journeyComplete = moment().format("MMMM Do YYYY, h:mm:ss a");
        }
      }
      this.passDetailsContent = '';
      if (this.allroute_markers.length > 0) {
        for (let inst = 0; inst < this.allroute_markers.length; inst++) {
          this.allroute_markers[inst].setMap(null);
        }
        this.allroute_markers = [];
      }
      if (this.markers.length > 0) {
        for (let inst = 0; inst < this.markers.length; inst++) {
          this.markers[inst].setMap(null);
          this.directionsDisplay.setMap(null);
        }
      }
      if (this.path_his.length > 0) {
        for (var inst = 0; inst < this.path_his.length; inst++) {
          this.path_his[inst].setMap(null);
          this.pathline.setMap(null);
        }
        this.path_his = [];
        this.markers = [];
      }
      if (this.mqttarray.length != 0) {
        for (let inst = 0; inst < this.map_marker.length; inst++) {
          this.map_marker[inst].setMap(null);
        }
        for (let inst = 0; inst < this.flightPath.length; inst++) {
          this.flightPath[inst].setMap(null);
        }
        this.map_marker = [];
      }
    }
  }

  changindriver_loc(data) {
    if (this.current_driver.bid == data.bid) {
      if (this.changing_location_status == 6 || this.changing_location_status == 7 || this.changing_location_status == 8 || this.changing_location_status == 9 || this.changing_location_status == 16) {
        this.current_driver.Device_type_ = data.Device_type_;
        this.current_driver.a = data.a;
        this.current_driver.app_version = data.app_version;
        this.current_driver.battery_Per = data.battery_Per;
        this.current_driver.bid = data.bid;
        this.current_driver.lg = data.lg;
        this.current_driver.lt = data.lt;
        this.current_driver.location_check = data.location_check;
        this.current_driver.st = data.st;
        var latlng = new google.maps.LatLng(data.lt, data.lg);
        this.current_driver_marker.setPosition(latlng);
        var latlongobj = { lat: this.current_driver.lt, lng: this.current_driver.lg }
        this.allpath_markers.push(latlongobj);
        var pos1 = new google.maps.LatLng(parseFloat(this.current_driver.lt), parseFloat(this.current_driver.lg));
        var infowindow = new google.maps.InfoWindow()
        var marker = new google.maps.Marker({
          position: pos1,
          icon: myGlobals.pathicn,
          map: this.map1
        });
        var content = this.current_driver.st;
        google.maps.event.addListener(marker, 'mouseover', (function (marker, content, infowindow) {
          return function () {
            infowindow.setContent(content);
            infowindow.open(this.map1, marker);
          };
        })(marker, content, infowindow));
        this.path_his.push(marker);
        var lineSymbol = {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        };
        this.pathline = new google.maps.Polyline
          ({
            path: this.allpath_markers,
            strokeOpacity: 0.8,
            strokeWeight: 3,
            strokeColor: '#4eff04',
            icons: [{
              icon: lineSymbol,
              repeat: '300px',
              strokeColor: 'red',
              offset: '100%'
            }],
            map: this.map1
          });

      }
    }
  }
  // THIS FUNCTION IS INTEDED TO LOAD THE MAP AFTER DETAILS BUTTON CLICK AFTER 0.5 SECOND
  // AND SHOWS ROUTE FROM POINT GOT FROM API
  displayRoute() {
    this.style = [{
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [{
        saturation: 36
      }, {
        color: "#000000"
      }, {
        lightness: 40
      }]
    }, {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [{
        visibility: "on"
      }, {
        color: "#000000"
      }, {
        lightness: 16
      }]
    }, {
      featureType: "all",
      elementType: "labels.icon",
      stylers: [{
        visibility: "off"
      }]
    }, {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 20
      }]
    }, {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 17
      }, {
        weight: 1.2
      }]
    }, {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 20
      }]
    }, {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 21
      }]
    }, {
      featureType: "road.highway",
      elementType: "all",
      stylers: [{
        hue: "#ff0000"
      }, {
        visibility: "simplified"
      }, {
        saturation: "-100"
      }, {
        lightness: "-67"
      }]
    }, {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{
        lightness: "25"
      }]
    }, {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{
        lightness: "-43"
      }, {
        saturation: "-14"
      }, {
        gamma: "1.01"
      }, {
        hue: "#ff0000"
      }, {
        visibility: "simplified"
      }]
    }, {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{
        lightness: "-70"
      }, {
        hue: "#a4ff00"
      }, {
        saturation: "-100"
      }]
    }, {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [{
        visibility: "on"
      }, {
        hue: "#ff0f00"
      }, {
        saturation: "4"
      }, {
        lightness: "-64"
      }]
    }, {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [{
        lightness: "-69"
      }, {
        visibility: "simplified"
      }, {
        gamma: "0.94"
      }, {
        hue: "#ff0000"
      }, {
        saturation: "-100"
      }]
    }, {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 19
      }]
    }, {
      featureType: "water",
      elementType: "geometry",
      stylers: [{
        color: "#0f252e"
      }, {
        lightness: 17
      }]
    }]
    var options = {
      zoom: 3,
      center: new google.maps.LatLng(12.9716, 77.5946),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
    };
    // END OF MAP STYLE
    // MAP LOADING 

    var that = this;
    that.mapr = new google.maps.Map(document.getElementById('map3'), {
      center: { lat: 12.9716, lng: 77.5946 },
      zoom: 8
    });
    that.mapr.setOptions({
      styles: that.style,
      minZoom: 2, maxZoom: 20,
      disableDefaultUI: true
    });


    setTimeout(() => {

      this.live_path_show(0);

    }, 100);
  }

  fileEvent(fileInput: any) {
    this.file = fileInput.target.files[0];
  }

  hideShow_job() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#job_details_button").addClass("active");
    $('.details_description').show();
  }
  hideShow_activity() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#activity_timeline_button").addClass("active");
    $('.details_description2').show();
  }
  hideShow_path() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#path_history_button").addClass("active");
    $('.details_description3').show();
    this.displayRoute();
  }
  hideShow_docs() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#documents_show").addClass("active");
    $('.details_description4').show();
  }
  hideShow_invoice() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#invoice_show").addClass("active");
    $('.details_description5').show();
  }
  hideShow_receipt() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#receipt_show").addClass("active");
    $('.details_description6').show();
  }

  // cancel booking api's
  cancelFees(bid) {
    $(".appt_loader_parent").show();
    this.cancel_reasons = [];
    this.cancellation_bid = "";
    this._dispatcherHomeService.cancelfees({
      bookingId: bid
    }).subscribe((res) => {
      $(".appt_loader_parent").hide();
      this.fee = res.message;
      this.cancelReason(bid);
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $(".appt_loader_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $(".appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".appt_loader_parent").hide();
            this.errmessage = JSON.parse(err._body);
            console.log(this.errmessage.message);
            this.errmessage = this.errmessage.message;
            break;
        }
      });
  }
  cancelReason(bid) {
    $(".appt_loader_parent").show();
    this.cancel_reasons = [];
    this.cancellation_bid = "";
    this._dispatcherHomeService.cancelreasons({
    }).subscribe((res) => {
      $(".appt_loader_parent").hide();
      res.data.bid = bid;
      this.cancel_reasons = res.data;
      $("#appcancel_rs").modal('show');
      $("#details_task").modal('hide');
      this.cancellation_bid = bid;
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $(".appt_loader_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $(".appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".appt_loader_parent").hide();
            this.errmessage = JSON.parse(err._body);
            console.log(this.errmessage.message);
            this.errmessage = this.errmessage.message;
            break;
        }
      });
  }
  cancelappt(bid) {
    var reason = $('input[name="quality"]:checked').val();
    this._dispatcherHomeService.cancelservice({
      bookingId: this.cancellation_bid.toString(),
      reason: reason,
    }).subscribe((res) => {
      $("#appcancel_rs").modal('hide');
      swal(this.cancelbooking.bookingCancel, this.cancelbooking.cancelCharges, this.cancelbooking.success);
      $("#details_task").modal('hide');
      this.wallet();
      if ($("#assigned_but").hasClass('active')) {
        this.assigned = jQuery.grep(this.assigned, (value) => {
          if (value.bookingId == this.cancellation_bid.toString()) {
            const index = this.assigned.findIndex(array => array.bookingId === this.cancellation_bid.toString());
            this.assigned.splice(index, 1);
            value.status = 4;
            value.statusText = "You cancelled.";
            this.completed_count = this.completed_count + 1;
            this.past.splice(0, 0, value);

            if (this.allroute_markers.length > 0) {
              for (let inst = 0; inst < this.allroute_markers.length; inst++) {
                this.allroute_markers[inst].setMap(null);
              }
              this.allroute_markers = [];
            }
            if (this.markers.length > 0) {
              for (let inst = 0; inst < this.markers.length; inst++) {
                this.markers[inst].setMap(null);
                this.directionsDisplay.setMap(null);
              }
            }
            if (this.path_his.length > 0) {
              for (var inst = 0; inst < this.path_his.length; inst++) {
                this.path_his[inst].setMap(null);
                this.pathline.setMap(null);
              }
              this.path_his = [];
              this.markers = [];
            }
            if (this.mqttarray.length != 0) {
              for (let inst = 0; inst < this.map_marker.length; inst++) {
                this.map_marker[inst].setMap(null);
              }
              for (let inst = 0; inst < this.flightPath.length; inst++) {
                this.flightPath[inst].setMap(null);
              }
              this.map_marker = [];
            }
          }
          return value.bookingId != this.cancellation_bid.toString();
        });
        console.log(this.assigned);
      }
      else {
        this.unassigned = jQuery.grep(this.unassigned, (value) => {
          if (value.bookingId == this.cancellation_bid.toString()) {
            this.assigned_full_count = this.assigned_full_count - 1;
            value.status = 4;
            value.statusText = "You cancelled.";
            this.completed_count = this.completed_count + 1;
            this.past.splice(0, 0, value);
          }
          return value.bookingId != this.cancellation_bid.toString();
        });
      }
      this.passDetailsContent = "";
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $(".appt_loader_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $(".appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $(".appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $(".appt_loader_parent").hide();
            this.errmessage = JSON.parse(err._body);
            console.log(this.errmessage.message);
            this.errmessage = this.errmessage.message;
            break;
        }
      });
  }
  // live path
  live_path_show(item) {
    this.markerdata = item;
    var map_plot;
    if (item == 0) {
      if (this.path_his.length > 0) {
        for (var inst = 0; inst < this.path_his.length; inst++) {
          this.path_his[inst].setMap(null);
        }
        this.pathline.setMap(null);
      }
      if (this.markers.length > 0) {
        for (var inst = 0; inst < this.markers.length; inst++) {
          this.markers[inst].setMap(null);
        }
      }
      this.path_his = [];
      this.markers = [];
      item = this.passDetailsContent;
      map_plot = this.mapr;
    }
    else {
      map_plot = this.map1
    }
    if (this.path_his.length > 0) {
      for (var inst = 0; inst < this.path_his.length; inst++) {
        this.path_his[inst].setMap(null);
      }
    }
    this.path_his = [];
    this.markers = [];
    this._dispatcherHomeService.getbookingspath({
      bookingId: item.bookingId
    }).subscribe((res) => {
      var stops = 0;
      if (res.data["6"] != undefined) {
        stops = stops + res.data["6"].length;
      }
      if (res.data["7"] != undefined) {
        stops = stops + res.data["7"].length;
      }
      if (res.data["9"] != undefined) {
        stops = stops + res.data["9"].length;
      }
      if (res.data["12"] != undefined) {
        stops = stops + res.data["12"].length;
      }
      if (stops > 1) {
        var bounds = new google.maps.LatLngBounds();
        var infowindow = new google.maps.InfoWindow()
        var infowindow1 = new google.maps.InfoWindow({
          content: '<div id="content">Pickup Location</div>'
        });
        var infowindow2 = new google.maps.InfoWindow({
          content: '<div id="content">Drop Location</div>'
        });

        if (this.id == 2) {
          if (item.pickup != undefined) {
            var pos1 = new google.maps.LatLng(item.pickup.latitude, item.pickup.longitude);
            var pos2 = new google.maps.LatLng(item.drop.latitude, item.drop.longitude);
          }
        } else {
          if (this.passDetailsContent.address != undefined) {
            var pos1 = new google.maps.LatLng(this.passDetailsContent.address.pickupLat, this.passDetailsContent.address.pickLong);
            var pos2 = new google.maps.LatLng(this.passDetailsContent.address.dropLat, this.passDetailsContent.address.dropLong);
          }
        }
        var marker1 = new google.maps.Marker({
          position: pos1,
          icon: myGlobals.pickupicn,
          map: this.map1
        });

        marker1.addListener('click', () => {
          infowindow1.open(map_plot, marker1);
        });
        bounds.extend(marker1.position);
        this.markers.push(marker1);

        if (item.drop != undefined) {
          if (item.drop.latitude != 0) {
            var marker2 = new google.maps.Marker({
              position: pos2,
              icon: myGlobals.dropupicn,
              map: this.map1
            });
            marker2.addListener('click', () => {
              infowindow2.open(map_plot, marker2);
            });
            this.markers.push(marker2);
            bounds.extend(marker2.position);
          }
        }

        if (this.id == 2) {
          this.setMarkers(this.driverMarker, this.pickupMarker, this.dropMarker);
        }

        if (res.data["6"] != undefined) {
          var icn = myGlobals.start_icn;
          for (var inst = 0; inst < res.data["6"].length; inst++) {
            var latlong = res.data["6"][inst].split(",");
            var latlongobj = { lat: parseFloat(latlong[0]), lng: parseFloat(latlong[1]) }
            this.allpath_markers.push(latlongobj);
            var pos1 = new google.maps.LatLng(parseFloat(latlong[0]), parseFloat(latlong[1]));
            var marker = new google.maps.Marker({
              position: pos1,
              icon: icn,
              map: map_plot
            });
            var content = "Driver on the way"

            google.maps.event.addListener(marker, 'mouseover', ((marker, content, infowindow) => {
              return () => {
                infowindow.setContent(content);
                infowindow.open(map_plot, marker);
              };
            })(marker, content, infowindow));
            this.path_his.push(marker);
            icn = myGlobals.pathicn;
            bounds.extend(marker.position);
            map_plot.fitBounds(bounds);
          }
        }
        if (res.data["7"] != undefined) {
          var icn = myGlobals.arrived_icn;
          for (var inst = 0; inst < res.data["7"].length; inst++) {
            var latlong = res.data["7"][inst].split(",");
            var latlongobj = { lat: parseFloat(latlong[0]), lng: parseFloat(latlong[1]) }
            this.allpath_markers.push(latlongobj);
            var pos1 = new google.maps.LatLng(parseFloat(latlong[0]), parseFloat(latlong[1]));
            var marker = new google.maps.Marker({
              position: pos1,
              icon: icn,
              map: map_plot
            });
            var content = "Driver reached to pickup address"
            google.maps.event.addListener(marker, 'mouseover', (function (marker, content, infowindow) {
              return function () {
                infowindow.setContent(content);
                infowindow.open(this.map1, marker);
              };
            })(marker, content, infowindow));
            this.path_his.push(marker);
            this.path_his.push(marker);
            icn = myGlobals.pathicn;
            bounds.extend(marker.position);
            map_plot.fitBounds(bounds);
          }
        }
        if (res.data["9"] != undefined) {
          var icn = myGlobals.reached_icn;
          for (var inst = 0; inst < res.data["9"].length; inst++) {
            var latlong = res.data["9"][inst].split(",");
            var latlongobj = { lat: parseFloat(latlong[0]), lng: parseFloat(latlong[1]) }
            this.allpath_markers.push(latlongobj);
            var pos1 = new google.maps.LatLng(parseFloat(latlong[0]), parseFloat(latlong[1]));
            var marker = new google.maps.Marker({
              position: pos1,
              icon: icn,
              map: map_plot
            });
            var content = "Driver reached to destination"
            google.maps.event.addListener(marker, 'mouseover', (function (marker, content, infowindow) {
              return function () {
                infowindow.setContent(content);
                infowindow.open(map_plot, marker);
              };
            })(marker, content, infowindow));
            this.path_his.push(marker);
            icn = myGlobals.pathicn;
            bounds.extend(marker.position);
            map_plot.fitBounds(bounds);
          }
        }
        if (res.data["12"] != undefined) {
          var icn = myGlobals.completed_icn;
          for (var inst = 0; inst < res.data["12"].length; inst++) {
            var latlong = res.data["12"][inst].split(",");
            var latlongobj = { lat: parseFloat(latlong[0]), lng: parseFloat(latlong[1]) }
            this.allpath_markers.push(latlongobj);
            var pos1 = new google.maps.LatLng(parseFloat(latlong[0]), parseFloat(latlong[1]));
            var marker = new google.maps.Marker({
              position: pos1,
              icon: icn,
              map: map_plot
            });
            var content = "Booking Completed"
            google.maps.event.addListener(marker, 'mouseover', (function (marker, content, infowindow) {
              return function () {
                infowindow.setContent(content);
                infowindow.open(map_plot, marker);
              };
            })(marker, content, infowindow));
            this.path_his.push(marker);
            icn = myGlobals.pathicn;
            bounds.extend(marker.position);
            map_plot.fitBounds(bounds);
          }
        }
        var lineSymbol = {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        };
        this.pathline = new google.maps.Polyline
          ({
            path: this.allpath_markers,
            strokeOpacity: 0.8,
            strokeWeight: 3,
            strokeColor: '#4eff04',
            icons: [{
              icon: lineSymbol,
              repeat: '300px',
              strokeColor: 'red',
              offset: '100%'
            }],
            map: map_plot
          });
      }
      else {
        this.showgooglepath();
      }
    });
  }

  // THIS FUNCTION WILL PASS THE DETAILS TO RIGHT HAND SLIDER AND DETAILS POUPUP AND SHOWS ROUTE MAP...............
  showgooglepath() {
    if (this.passDetailsContent.address != undefined) {
      var pos1 = new google.maps.LatLng(this.passDetailsContent.address.pickupLat, this.passDetailsContent.address.pickLong);
      var pos2 = new google.maps.LatLng(this.passDetailsContent.address.dropLat, this.passDetailsContent.address.dropLong);
    } else {
      var pos1 = new google.maps.LatLng(this.markerdata.pickup.latitude, this.markerdata.pickup.longitude);
      var pos2 = new google.maps.LatLng(this.markerdata.drop.latitude, this.markerdata.drop.longitude);
    }
    var marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
    var marker2 = new google.maps.Marker({
      position: pos2,
      icon: myGlobals.dropupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker2);
    var directionsService2 = new google.maps.DirectionsService({ preserveViewport: true });
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: { strokeColor: "#00ff5b" }
    });
  }

  clearAllMarkers() {
    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = new Array();
  }

  // Review and Ratings
  // drop address after accepting
  dropadd() {
    setTimeout(() => {
      console.log("in drop function");
      var style = [
        {
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 13
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#144b53"
            },
            {
              "lightness": 14
            },
            {
              "weight": 1.4
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "color": "#08304b"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#0c4152"
            },
            {
              "lightness": 5
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#0b434f"
            },
            {
              "lightness": 25
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#0b3d51"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
            {
              "color": "#146474"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
            {
              "color": "#021019"
            }
          ]
        }
      ];

      var mapdrop = new google.maps.Map(document.getElementById('mapdrop'), {
        mapTypeControl: false,
        center: { lat: 12.9716, lng: 77.5946 },
        zoom: 13
      });
      mapdrop.setOptions({
        styles: style,
        minZoom: 2,
        maxZoom: 20
      });
      var destination_input = document.getElementById('dropaddress');
      var destination_autocomplete = new google.maps.places.Autocomplete(destination_input);
      if (destination_autocomplete) {
        destination_autocomplete.addListener('place_changed', () => {
          var place = destination_autocomplete.getPlace();
          this.changeDroplat = place.geometry.location.lat();
          this.changeDroplong = place.geometry.location.lng();
          this.changeAddress = place.formatted_address
          var pos = new google.maps.LatLng(this.changeDroplat, this.changeDroplong);
          if (this.dropchangeMarker == undefined) {
            this.dropchangeMarker = new google.maps.Marker({
              position: pos,
              icon: myGlobals.pickupicn,
              map: mapdrop,
              draggable: true
            });
          } else {
            this.dropchangeMarker.setPosition(pos);
          }
          const bounds = new google.maps.LatLngBounds();
          bounds.extend(this.dropchangeMarker.getPosition());
          mapdrop.fitBounds(bounds);
        })
      }
    }, 1000);
  }
  // update drop location
  addDropLocation() {
    if (this.changeDroplat != undefined || this.changeDroplat != null) {
      this._dispatcherHomeService.addDropLocation({
        "bookingId": this.bookingid.toString(),
        "dropLongitude": this.changeDroplong.toString(),
        "dropLatitude": this.changeDroplat.toString(),
        "dropAddress": this.changeAddress
      }).subscribe((res) => {
        const index = this.assigned.findIndex(array => array.bookingId === this.bookingid);
        this.assigned.splice(index, 1);
        this.singleBooking(this.singleId, this.singleStatus);
        swal("success", res.message);
        $('#dropadd').modal('hide');
      },
        (err) => {
          console.log('errMsg', err.status);
          if (err.status > 401 && err.status < 500) {
            err.status = 420; // merging all the status codes to one status code 420
          }
          if (err.status > 499) {
            err.status = 520; // merging all the status codes to one status code 420
          }
          switch (err.status) {
            case 0:
              $("#appt_loader_parent").hide();
              toastr["error"]("Bad Request!");
              break;
            case 520:
              $("#appt_loader_parent").hide();
              this.errMsg = JSON.parse(err._body);
              toastr["error"](this.errMsg.message);
              break;
            case 400:
              $("#appt_loader_parent").hide();
              this.errMsg = JSON.parse(err._body);
              toastr["error"](this.errMsg.message);
              break;
            case 401:
              this._cookie.removeItem();
              this._router.navigate(['login']);
              break;
            case 420:
              $(".appt_loader_parent").hide();
              this.adddrop = JSON.parse(err._body);
              this.adddrop = this.adddrop.message;
              setTimeout(() => {
                $(".remove_details #err").show();
              }, 300);
              break;
          }
        });
    } else {
      swal("warninng", "Please enter valid address!");
    }
  }
  // START OF FAVORITE DRIVER
  getfavdriver() {
    this._dispatcherHomeService.getfavdriver({
    }).subscribe((res) => {
      if (res.data.length > 0) {
        for (let inst = 0; inst < res.data.length; inst++) {
          if (res.data[inst].isOnline == true) {
            this.favDiverId = res.data[inst].driverId;
            if (this.pendingDriverId == res.data[inst].driverId) {
              this.removeFav = true;
            }
          }
        }
      }
    });
  }
  postfavdriver() {
    this._dispatcherHomeService.postfavdriver({
      driverId: this.driverId
    }).subscribe((res) => {
      this.removeFav = true;
    });
  }
  patchfavdriver() {
    this._dispatcherHomeService.patchfavdriver({
      driverId: this.pendingDriverId
    }).subscribe((res) => {
      this.removeFav = false;
      for (let inst = 0; inst < res.data.length; inst++) {
        if (res.data[inst].isOnline == true) {
        }
      }
    });
  }
  // END OF FAVORITE DRIVER
  // review invoice
  reviewDetails() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#invoice_show").addClass("active");
    $('.details_description5').show();
  }
  // pending reviews
  pending_reviews() {
    this.pending_review = [];
    this._dispatcherHomeService.getpendingreviews({
    }).subscribe((res) => {
      if (res.data.length > 0) {
        for (let inst = 0; inst < res.data.length; inst++) {
          this.pending_review.push(res.data[inst]);
          this.pendingDriverId = res.data[inst].driver.id;
          this.pendingBookingId = res.data[inst].bookingId;
        }
        this.driverId = res.data[0].driver.id;
        setInterval(() => {
          $('#review_popup').modal({ backdrop: 'static', keyboard: false });
        }, 500);
        this.getfavdriver();
        this.getCustomerBookings1(res.data[0].bookingId, res.data[0].bookingStatus, 2);
      }
    });
  }
  // start of review and rating
  submitReivew(val) {               // submit review
    if ($("#review_content").val() == '') {
      this.comment_error = true;
    }
    else {
      var comment = $("#review_content").val();
      var review = $('input[name=cb]:checked').val();
      if (review == '') {
        swal("Warning", "Please give the rating!", "warning");
      } else {
        this.submitreview_call(comment, review);
      }
    }
  }
  submitreview_call(comment, review) {
    $(".appt_loader_parent").show();
    var bid = this.pending_review[0].bookingId;
    this._dispatcherHomeService.postreview({
      bookingId: bid.toString(),
      rating: this.rating,
      review: this.high_rating.toString()
    }).subscribe((res) => {
      $("#review_popup").modal('hide');
      $(".appt_loader_parent").hide();
      this.comments = '';
      this.cardDeduct = 0;
      this.pending_reviews();
    });
  }
  callpendingreivews(value) {
    if (value == 1) {
    }
    else {
      if (this.pending_review.length > 0) {
        $("#review_popup").modal({ backdrop: 'static', keyboard: false });
      }
    }
  }
  ratingcomments(val) {
    this._dispatcherHomeService.getratings({
    }).subscribe((res) => {
      this.rating = val;
      switch (val) {
        case 1: this.comments = res.data.rating1;
          break;
        case 2: this.comments = res.data.rating2;
          break;
        case 3: this.comments = res.data.rating3;
          break;
        case 4: this.comments = res.data.rating4;
          break;
        case 5: this.comments = res.data.rating5;
          break;
      }
    });
  }
  show_raing_txt(rate) {
    $("input[name=selector_review]").val($("input[name=selector_review] option:first").val());
    this.high_rating = [];
    this.rating_text = [];
    this.show_low_rating = true;
    this.ratingcomments(rate);
    this.show_high_rating = false;
    for (var key in this.driver_rating) {
      if (key == rate) {
        this.rating_text = this.driver_rating[key];
        break;
      }
    }
  }
  addhigh_reviews(text) {
    const indexofReview = this.high_rating.findIndex(i => i === text);
    if (indexofReview == -1) {
      this.high_rating.push(text);
    } else {
      this.high_rating.splice(indexofReview, 1);
    }
  }
  // end of review and rating

  ngOnInit() {
    this.information = JSON.parse(sessionStorage.getItem('ipinformation'));
    this.onLoadLatitude = this.information.latitude;
    this.onLoadLongitude = this.information.longitude;
    this.clearallpassdetails();
    this.pending_reviews();
    this.myname = this._cookie.getItem('firstName');
    this.myphn = this._cookie.getItem('phone');
    this.mymail = this._cookie.getItem('email');
    // Toaseter
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-top-right",
      "preventDuplicates": true,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "8000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    this.disphome = this.languageService.dispatcherhome;
    this.jobdetails = this.languageService.job_details;
    this.invoice = this.languageService.invoice;
    this.cancelbooking = this.languageService.cancel_booking;
    this.bookcomplete = this.languageService.bookingComplete;
    this.currency = sessionStorage.getItem('currency');
    $(".booking_buutns").show();
    // MAP STYLES FOR ALL FILTERS
    var styles = {
      default: [
        {
          "featureType": "all",
          "elementType": "all",
          "stylers": [
            {
              "invert_lightness": true
            },
            {
              "saturation": 10
            },
            {
              "lightness": 30
            },
            {
              "gamma": 0.5
            },
            {
              "hue": "#435158"
            }
          ]
        }
      ],
      silver: [
        {
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }]
        },
        {
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }]
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#f5f5f5' }]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#bdbdbd' }]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#dadada' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }]
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }]
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#c9c9c9' }]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }]
        }
      ],

      night: [
        { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
        {
          featureType: 'administrative.locality',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#d59563' }]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#d59563' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#263c3f' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#6b9a76' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#38414e' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#212a37' }]
        },
        {
          featureType: 'road',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9ca5b3' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#746855' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#1f2835' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#f3d19c' }]
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#2f3948' }]
        },
        {
          featureType: 'transit.station',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#d59563' }]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#17263c' }]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#515c6d' }]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#17263c' }]
        }
      ],

      retro: [
        { elementType: 'geometry', stylers: [{ color: '#ebe3cd' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#523735' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f1e6' }] },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#c9b2a6' }]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#dcd2be' }]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#ae9e90' }]
        },
        {
          featureType: 'landscape.natural',
          elementType: 'geometry',
          stylers: [{ color: '#dfd2ae' }]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#dfd2ae' }]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#93817c' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry.fill',
          stylers: [{ color: '#a5b076' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#447530' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#f5f1e6' }]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [{ color: '#fdfcf8' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#f8c967' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#e9bc62' }]
        },
        {
          featureType: 'road.highway.controlled_access',
          elementType: 'geometry',
          stylers: [{ color: '#e98d58' }]
        },
        {
          featureType: 'road.highway.controlled_access',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#db8555' }]
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#806b63' }]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [{ color: '#dfd2ae' }]
        },
        {
          featureType: 'transit.line',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#8f7d77' }]
        },
        {
          featureType: 'transit.line',
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#ebe3cd' }]
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [{ color: '#dfd2ae' }]
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [{ color: '#b9d3c2' }]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#92998d' }]
        }
      ],

      hiding: [
        {
          featureType: 'poi.business',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        }
      ]

    };

    var style_common = [
      {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#000000"
          },
          {
            "lightness": 13
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#000000"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#144b53"
          },
          {
            "lightness": 14
          },
          {
            "weight": 1.4
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
          {
            "color": "#08304b"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#0c4152"
          },
          {
            "lightness": 5
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#000000"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#0b434f"
          },
          {
            "lightness": 25
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#000000"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#0b3d51"
          },
          {
            "lightness": 16
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#000000"
          }
        ]
      },
      {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
          {
            "color": "#146474"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
          {
            "color": "#021019"
          }
        ]
      }
    ];

    var what = this;                                    // INSTAILIZATIN OF MAP BASED ON CURRENT LOCATION
    // jQuery.get("https://ipinfo.io", (response) => {
    //   this.onLoadLatitude = (response.loc).split(",")[0];
    //   this.onLoadLongitude = (response.loc).split(",")[1];
    var that = this;

    // INITIALIZING MAP
    var map = new google.maps.Map(document.getElementById('mapP'), {
      center: new google.maps.LatLng(this.onLoadLatitude, this.onLoadLongitude),
      zoom: 13,
      minZoom: 1,
      styles: style_common,
      disableDefaultUI: true
    });
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((e) => {
        var position_marker = new google.maps.LatLng(e.coords.latitude, e.coords.longitude);
        var infowindow = new google.maps.InfoWindow();
        this.current_location_marker = new google.maps.Marker({
          position: position_marker,
          icon: myGlobals.currenticn,
          map: map
        });
        this.allroute_markers.push(this.current_location_marker);
        map.setCenter(position_marker);
        map.setZoom(18);
      });
    } else {
    }
    this.map1 = map;
    var current_location;


    what.map1 = map;
    // GETTING GODSVIEW PROVIDERS LIST
    // MAP FILTER DROP DOWN
    var those = what;
    jQuery(".radio_buttons").click(function () {
      var that = this;
      if ($(this).val() != "default") {
        that.map_layer = $(this).val();
        those.map1.setOptions({ styles: styles[that.map_layer] });
      }
      else {
        those.map1.setOptions({ styles: styles["default"] });
      }
    });
    what.map1.setOptions({
      minZoom: 2, maxZoom: 40
    });
    //}, "jsonp");                                 // END OF ---- INSTAILIZATIN OF MAP BASED ON CURRENT LOCATION

    $("#hidden_flipping_assign").click(() => {
      var content = $("#hidden_flipping_assign").text();
      var splitted_content = content.split(',');
      var bid = splitted_content[0];
      var status = splitted_content[1];
      var msg = splitted_content[2];
      var date_bid = splitted_content[3];
      for (var inst = 0; inst < this.data2.length; inst++) {
        if (this.data2[inst].bid == bid) {
          this.data2[inst].status = status;
          this.data2[inst].status = msg;
          switch (status) {
            case "7":
              this.data2[inst].DriverArrivedTime = date_bid;
              break;
            case "8":
              this.data2[inst].DriverLoadedStartedTime = date_bid;
              break;
            case "9":
              this.data2[inst].DriverReachedDropLocationTime = date_bid;
              break;
            case "16":
              this.data2[inst].DriverDropedTime = date_bid;
              break;
          }
          break;
        }
      }
    });

    $('#load_more').click(() => {
      this.page_index++;
      // ------------------------------------------------
      this.getAllBooking(this.type);
    });
    $('#load_more').mouseover(function () {
      $(".more_tooltip").show();
    });
    $('#load_more').mouseout(function () {
      $(".more_tooltip").hide();
    });

    // DETAIL POPUP HIDE AND SHOW
    $(".details_description2").hide();
    $(".details_description3").hide();
    //FILTER TOOGLE ANIMATION

    $('#floating_button_body').hide();
    $("#floating_button").click(function () {
      $("#floating_button_body").toggle(
        function () {
          $('#floating_button_body').animate({
            height: "auto",
          });
        });
    })

    // DATE FILTER FOR FILTERING ASSIGNED AND UNASSIGNED TASKS
    $('#header_date_picker').change(() => {
    });

    // END OF DATE FILTER FOR FILTERING ASSIGNED AND UNASSIGNED TASKS
    $("#hidden_btn").click(() => {
      this.assigned = [];
      this.unassigned = [];
      this.past = [];
      // ------------------------------------------------
      this.getAllBooking(1);
      this.getAllBooking(2);
      this.getAllBooking(3);
    });
    // ------------------------------------------------
    this.getAllBooking(1);
    this.getAllBooking(2);
    this.getAllBooking(3);

    this.getvehicles();
    this.fname_b = localStorage.getItem('fname');
    this.fmail_b = localStorage.getItem('emailId')
    this.fphone_b = localStorage.getItem('cust_phone')

    jQuery('.phone_num_valid').keyup(function () {
      this.value = this.value.replace(/[^0-9\.]/g, '');
    });

    $(".vehicletypes_but").on('click', 'li', function () {
      $(".btn:first-child").text($(this).text());
      $(".btn:first-child").val($(this).text());
      this.vechicle_type = $(this).attr('id');
      localStorage.setItem('vechileType', this.vechicle_type);
    });

    $('#wght_value').keypress(function (event) {
      var $this = $(this);
      if ((event.which != 46 || $this.val().indexOf('.') != -1) &&
        ((event.which < 48 || event.which > 57) &&
          (event.which != 0 && event.which != 8))) {
        event.preventDefault();
      }

      var text = $(this).val();
      if ((event.which == 46) && (text.indexOf('.') == -1)) {
        setTimeout(function () {
          if ($this.val().substring($this.val().indexOf('.')).length > 3) {
            $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
          }
        }, 1);
      }

      if ((text.indexOf('.') != -1) &&
        (text.substring(text.indexOf('.')).length > 2) &&
        (event.which != 0 && event.which != 8) &&
        ($(this)[0].selectionStart >= text.length - 2)) {
        event.preventDefault();
      }
    });

    $("#add_popup_but").click(function () {
    });

    $(function () {
      $(document.body).on('show.bs.modal', function () {
        $(document.body).addClass('modal-open');
      });
      $(document.body).on('hide.bs.modal', function () {
        $(document.body).removeClass('modal-open');
      });
    });

    var map;
    jQuery('#back_button').hide();

    jQuery('.front_div_close').click(function () {
    });
    jQuery('#right_taks_but').click(function () {
      jQuery('.tasks_list_right').toggle();
    });

    jQuery('.connections_div').click(function () {
    });

    jQuery('#offline_dri_head').click(function () {
      jQuery('.connections_div_all').hide();
      jQuery('#offline_drivers_div').show();
    });

    jQuery('#total_dri_head').click(function () {
      jQuery('.connections_div_all').hide();
      jQuery('#total_drivers_div').show();
    });

    jQuery('#online_dri_head').click(function () {
      jQuery('.connections_div_all').hide();
      jQuery('#online_drivers_div').show();
    });

    jQuery('#path_history_button').click(() => {
      jQuery('.tabs_details').hide();
      jQuery('.path_history').show();
      jQuery('.details_but_sytle').removeClass("active");
      jQuery(this).addClass('active');
    });
    jQuery('#job_details_button').click(function () {
      jQuery('.tabs_details').hide();
      jQuery('.details_description').show();
      jQuery('.details_but_sytle').removeClass("active");
      jQuery(this).addClass('active');
    });
    jQuery('#activity_timeline_button').click(function () {
      jQuery('.tabs_details').hide();
      jQuery('.activity_timeline').show();
      jQuery('.details_but_sytle').removeClass("active");
      jQuery(this).addClass('active');
    });

    $("ul.details_popup_menu").on("click", "#activity_timeline_button", function () {
    });

    jQuery('#job_details_button').trigger('click');
    jQuery('#bulk_import_but').click(function () {
      jQuery('#bulk_import_but').find('span').toggleClass("active");
    });

    $('#assigned_but').click(() => {
      this.type = 2;
      this.passDetailsContent = '';
      $(".common_tasks").hide();
      $(".assigned_jobs").show();
      this.clearAllMarkers();
      this.clearallpassdetails();
    });
    $('#un_assigned_but').click(() => {
      this.type = 1;
      this.passDetailsContent = '';
      $(".common_tasks").hide();
      $(".un_assigned_jobs").show();
      this.clearAllMarkers();
      this.clearallpassdetails();
    });
    $('#completed_but').click(() => {
      this.type = 3;
      this.passDetailsContent = '';
      $(".common_tasks").hide();
      $(".completed_jobs").show();
      this.clearAllMarkers();
      this.clearallpassdetails();
    });

    jQuery(".width_3").click(function () {
      jQuery(".width_3").removeClass("active");
      jQuery(this).addClass("active");
    });
    jQuery(".width_3_rt").click(function () {
      jQuery(".width_3_rt").removeClass("active");
      jQuery(this).addClass("active");
    });

    jQuery(".left_marker").click(function () {
      var k = jQuery('.left-window').width();
      var y = jQuery(window).width();
      var result = y - k;
      if (jQuery(".left-window").hasClass('open')) {
        jQuery(".left-window").animate({ left: -k });
        jQuery(".left-window").removeClass('open');
        jQuery(".icn_left").addClass('rotate_pointer');
        jQuery('#map>div').animate({ marginLeft: '0%' });
      }
      else {
        jQuery(".left-window").animate({ left: '0' });
        jQuery(".left-window").addClass('open');
        jQuery(".icn_left").removeClass('rotate_pointer');
        jQuery('#map>div').animate({ marginLeft: k });
      }
    });

    jQuery(".right_marker").click(function () {
      var k = jQuery('.left-window').width();
      var y = $(window).width();
      var result = y - k;
      if (jQuery(".right-window").hasClass('open')) {
        jQuery(".right-window").animate({ right: -k });
        jQuery(".right-window").removeClass('open');
        jQuery(".icn_right").addClass('rotate_pointer');
        jQuery('#map>div').animate({ width: '100%' });
      }
      else {
        jQuery(".right-window").animate({ right: '0' });
        jQuery(".right-window").addClass('open');
        jQuery(".icn_right").removeClass('rotate_pointer');
        jQuery('#map>div').animate({ width: result });
      }
    });

    $('#search_picker').click(() => {
      if (this.type == 1) {
        this.unassigned = [];
      } else if (this.type == 2) {
        this.assigned = [];
      } else {
        this.past = [];
      }
      this.picker_date = $("#header_date_picker2").val();
      this.drop_date = $("#header_date_picker").val();
      if (this.picker_date == "" || this.drop_date == "") {
        alert(this.cancelbooking.validDateRange);
      }
      else {
        this.current_time = moment().format('YYYY-MM-DD HH:mm:ss');
        $("#loader_bookings_parent").show();
        this.getAllBooking(this.type);
      }
    });

    $('#details_task').on('hidden.bs.modal', () => {
      $('#job_details_button').trigger('click');
    })

    // This example requires the Places library. Include the libraries=places
    // parameter when you first load the API. For example:
    // <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
  }
  // refresh bookings
  refresh_all_fil() {
    this.assigned = [];
    this.unassigned = [];
    this.past = [];
    this.picker_date = '';
    this.drop_date = '';
    this.getAllBooking(1);
    this.getAllBooking(2);
    this.getAllBooking(3);
  }
  // clear markers
  clearallpassdetails() {
    if (this.allroute_markers.length > 0) {
      for (var inst = 0; inst < this.allroute_markers.length; inst++) {
        this.allroute_markers[inst].setMap(null);
      }
      this.allroute_markers = [];
    }
    if (this.pathline != undefined && this.pathline != '') {
      this.pathline.setMap(null);
    }
    if (this.directionsDisplay != undefined && this.directionsDisplay != '') {
      this.directionsDisplay.setMap(null);
    }
    if (this.path_his.length > 0) {
      for (var inst = 0; inst < this.path_his.length; inst++) {
        this.path_his[inst].setMap(null);
      }
    }
  }
  zoomin() {
    var m = this.map1.getZoom();
    this.map1.setZoom(m - 1);
  }
  zoomout() {
    var m = this.map1.getZoom();
    this.map1.setZoom(m + 1);
  }
  getvehicles() {
    this.current_time = new Date();
    this.current_time_var = this.current_time.getFullYear() + '-' + ("0" + (this.current_time.getMonth() + 1)).slice(-2) + '-' + this.current_time.getDate() + " " + (this.current_time.getHours() + 3) + ":" + this.current_time.getMinutes() + ":" + this.current_time.getSeconds();
    flatpickr(".flatpickr", {
      defaultDate: 1477697199863, // Date objects and date strings are also accepted
      enableTime: true,
      enableSeconds: true,
      minDate: this.current_time_var, // "today" / "2016-12-20" / 1477673788975
      // maxDate: "2018-12-20",

    },
    );
    flatpickr(".flatpickr2", {
      defaultDate: new Date(), // Date objects and date strings are also accepted
      enableTime: false,
      altFormat: "M j, Y"
    });
  }
  // START OF UBER FOR ALL FUNCTIONS
  // pagination LoadMore bookings
  onScroll(e, status) {
    switch (status) {
      //pagination for Assigned Booking list , it will add the next list to the existing array
      case 1:
        if ($('#unasgn_left_full_body').scrollTop() + $('#unasgn_left_full_body').innerHeight() >= $('#unasgn_left_full_body')[0].scrollHeight) {
          this.limit = this.limit + 10;
          this.skip = 0;
          this.getAllBooking(1);
        }
        break;
      case 2:
        if ($('#asgn_left_full_body').scrollTop() + $('#asgn_left_full_body').innerHeight() >= $('#asgn_left_full_body')[0].scrollHeight) {
          this.limit = this.limit + 10;
          this.skip = 0;
          this.getAllBooking(2);
        }
        break;
      case 3:
        if ($('#past_left_full_body').scrollTop() + $('#past_left_full_body').innerHeight() >= $('#past_left_full_body')[0].scrollHeight) {
          this.limit = this.limit + 10;
          this.skip = 0;
          this.getAllBooking(3);
        }
        break;
    }
  }
  // get all bookings
  getAllBooking(type) {
    $("#loader_bookings_parent").show();
    this._dispatcherHomeService.getAllBooking({
      type: type,
      limit: this.limit,
      skip: this.skip,
      status: this.status,
      fromDate: this.picker_date,
      toDate: this.drop_date,
    }).subscribe((res) => {
      $("#appt_loader_parent").hide();
      if (res.data.length == 0) {
        $(".more_tooltip_error").show();
        setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
      }
      else {
        for (let i = 0; i < res.data.bookings.length; i++) {
          if (res.data.bookings[i].dateAndTime.accepted != 0) {
            res.data.bookings[i].dateAndTime.accepted = moment(res.data.bookings[i].dateAndTime.accepted).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.onTheWay != 0) {
            res.data.bookings[i].dateAndTime.onTheWay = moment(res.data.bookings[i].dateAndTime.onTheWay).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.arrived != 0) {
            res.data.bookings[i].dateAndTime.arrived = moment(res.data.bookings[i].dateAndTime.arrived).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.created != 0) {
            res.data.bookings[i].dateAndTime.created = moment(res.data.bookings[i].dateAndTime.created).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.cancelled != 0) {
            res.data.bookings[i].dateAndTime.cancelled = moment(res.data.bookings[i].dateAndTime.cancelled).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.journeyComplete != 0) {
            res.data.bookings[i].dateAndTime.journeyComplete = moment(res.data.bookings[i].dateAndTime.journeyComplete).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.journeyStart != 0) {
            res.data.bookings[i].dateAndTime.journeyStart = moment(res.data.bookings[i].dateAndTime.journeyStart).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.bookings[i].dateAndTime.unloaded != 0) {
            res.data.bookings[i].dateAndTime.unloaded = moment(res.data.bookings[i].dateAndTime.unloaded).format("MMMM Do YYYY, h:mm:ss a");
          }
        }
        if (type == 1) {
          this.unassigned = res.data.bookings;
          this.assigned_full_count = res.data.count;
        } else if (type == 2) {
          this.assigned = res.data.bookings;
          this.assigned_count = res.data.count;
        } else if (type == 3) {
          this.past = res.data.bookings;
          this.completed_count = res.data.count;
        }
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $("#loader_bookings_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
        }
      })
  }
  // bookings history
  getCustomerBooking() {
    this.assigned = [];
    this.unassigned = [];
    this.past = [];
    if (this.page_index == 0) {
      this.assigned_count = 0;
      this.completed_count = 0;
      this.assigned_full_count = 0;
    }
    $("#appt_loader_parent").show();
    this._dispatcherHomeService.gethistory({
    }).subscribe((res) => {
      $("#appt_loader_parent").hide();
      if (res.data.length == 0) {
        $(".more_tooltip_error").show();
        setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
      }
      else {
        var response_ins = 0;
        const bookingData = res.data;
        var d = new Date();
        var offsetTime = d.getTimezoneOffset();
        for (let asgn = 0; asgn < bookingData.assigned.length; asgn++) {
          if (bookingData.assigned.status == 6, 7, 8, 9, 10, 11) {
            this.assigned.push(bookingData.assigned[asgn]);
            this.assigned[asgn].bookingDate = moment(this.assigned[asgn].bookingDate).subtract(offsetTime, 'minutes').format("MMMM Do YYYY, h:mm:ss a");
            this.assigned_count = this.assigned.length;
          }
        }

        for (let unasgn = 0; unasgn < bookingData.unassigned.length; unasgn++) {
          if (bookingData.unassigned[unasgn].status == 1, 2) {
            const date = res.data.unassigned[unasgn].bookingDate + ', ' + res.data.unassigned[unasgn].bookingTime;
            res.data.unassigned[unasgn].bookingDate = moment(date).subtract(offsetTime, 'minutes').format("MMMM Do YYYY, h:mm:ss a");
            this.unassigned.push(bookingData.unassigned[unasgn]);
            this.assigned_full_count = this.unassigned.length;
          }
        }

        for (let past = 0; past < bookingData.past.length; past++) {
          if (bookingData.past[past].status == 3, 4, 5, 12, 13) {
            res.data.past[past].bookingDate = moment(bookingData.past[past].bookingDate).subtract(offsetTime, 'minutes').format("MMMM Do YYYY, h:mm:ss a");
            this.past.push(bookingData.past[past]);
            this.completed_count = this.past.length;
          }
        }
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $("#appt_loader_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $("#appt_loader_parent").hide();
            this.errmessage = JSON.parse(err._body);
            console.log(this.errmessage.message);
            this.errmessage = this.errmessage.message;
            break;
        }
      })
  }
  // single booking api
  singleBooking(bookingId, status) {
    this.singleId = bookingId;
    this.singleStatus = status;
    $("#appt_loader_parent").show();
    this._dispatcherHomeService.getdata({
      bookingId: bookingId,
      callFrom: 2
    }).subscribe((res) => {
      var d = new Date();
      var offsetTime = d.getTimezoneOffset();
      $("#appt_loader_parent").hide();
      if (status == 6 || 7 || 8 || 9 || 10 || 11) {
        res.dataForDispatcher.bookingDate = moment(res.dataForDispatcher.bookingDate).subtract(offsetTime, 'minutes').format("MMMM Do YYYY, h:mm:ss a");
        this.assigned.push(res.dataForDispatcher);
        $('#assigned_but').trigger('click');
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $("#appt_loader_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
        }
      })
  }
  // booking path
  bookingPath(bookingId) {
    $("#appt_loader_parent").show();
    this._dispatcherHomeService.getbookingspath({
      bookingId: bookingId
    }).subscribe((res) => {
      $("#appt_loader_parent").hide();
      for (let inst = 0; inst < res.data.activities.length; inst++) {
      }
    })
  }
  // set markers
  setMarkers(driver, pickup, drop) {
    if (driver.latitude != undefined && pickup.latitude != undefined && drop.latitude != undefined) {
      var pos = { lat: driver.latitude, lng: driver.longitude };
      var pos1 = { lat: pickup.latitude, lng: pickup.longitude };
      var pos2 = { lat: drop.latitude, lng: drop.longitude };
    }
    if (driver.latitude == undefined && pickup.latitude == undefined && drop.latitude == undefined) {
      var pos = { lat: driver.latitude, lng: driver.longitude };
      var pos1 = { lat: this.passDetailsContent.address.pickupLat, lng: this.passDetailsContent.address.pickLong };
      var pos2 = { lat: this.passDetailsContent.address.dropLat, lng: this.passDetailsContent.address.dropLong };
    }
    this.driverlat = driver.latitude;
    this.driverlong = driver.longitude;
    this.pickuplat = pickup.latitude;
    this.pickuplong = pickup.longitude;
    this.droplat = drop.latitude;
    this.droplong = drop.longitude;

    var icon = {
      url: this.vehicle_icon, // url
      scaledSize: new google.maps.Size(30, 30), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(0, 0) // anchor
    };
    var statusArr = [3, 4, 5, 12, 13];
    if (statusArr.indexOf(parseInt(this.liveStatus)) == -1) {
      this.driver_marker_loc = new google.maps.Marker({
        icon: icon,
        position: pos,
        map: this.map1
      });
      this.driver_marker_loc.id = driver.mqttTopic;
      this.markers.push(this.driver_marker_loc);
      this.mqttsubscribe(driver.mqttTopic);
    }
    var directionsService2 = new google.maps.DirectionsService({ preserveViewport: true });
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: { strokeColor: "#00ff5b" }
    });
    this.directionsDisplay.setMap(this.map1);
  }
  // draw route
  drawroute() {
    var origin = this.driverlat + ', ' + this.driverlong; // using pickuplat
    var destination = this.mqttlat + ', ' + this.mqttlong;                // using droplat long

    var currentLatLong = {
      lat: this.mqttlat,
      lng: this.mqttlong
    };
    let driverLastLat;
    let driverLastLong;

    if (this.mqttarray.length > 0) {
      let lastLatLng = this.mqttarray[this.mqttarray.length - 1];
      driverLastLat = lastLatLng.lat;
      driverLastLong = lastLatLng.lng;
    } else {
      driverLastLat = this.driverlat;
      driverLastLong = this.driverlong;
    }
    this.mqttarray.push(currentLatLong);

    var flightPlanCoordinates = [
      { lat: driverLastLat, lng: driverLastLong },
      { lat: this.mqttlat, lng: this.mqttlong }
    ];

    var lineSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
    };

    var polyline = new google.maps.Polyline({
      path: flightPlanCoordinates,
      geodesic: true,
      strokeColor: '#4fde8c',
      strokeOpacity: 1.0,
      strokeWeight: 2,
      icons: [{
        icon: lineSymbol,
        repeat: '300px',
        strokeColor: 'red',
        offset: '100%'
      }],
    });
    polyline.setMap(this.map1);
    this.flightPath.push(polyline);

    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(this.mqttlat, this.mqttlong),
      icon: "../assets/img/map_icon.png",
      map: this.map1
    });
    this.map_marker.push(marker);

  }
  // set markers empty
  markersEmpty() {
    if (this.directionsDisplay != undefined || this.directionsDisplay != null) {
      this.directionsDisplay.setMap(null);
    }
    if (this.allroute_markers.length > 0) {
      for (let inst = 0; inst < this.allroute_markers.length; inst++) {
        this.allroute_markers[inst].setMap(null);
      }
      this.allroute_markers = [];
    }
    if (this.markers.length > 0) {
      for (let inst = 0; inst < this.markers.length; inst++) {
        this.markers[inst].setMap(null);
        this.directionsDisplay.setMap(null);
      }
    }
    if (this.path_his.length > 0) {
      for (var inst = 0; inst < this.path_his.length; inst++) {
        this.path_his[inst].setMap(null);
        this.pathline.setMap(null);
      }
      this.path_his = [];
      this.markers = [];
    }
    if (this.mqttarray.length != 0) {
      for (let inst = 0; inst < this.map_marker.length; inst++) {
        this.map_marker[inst].setMap(null);
      }
      for (let inst = 0; inst < this.flightPath.length; inst++) {
        this.flightPath[inst].setMap(null);
      }
      this.map_marker = [];
    }
  }
  // bookings call
  passDetails(i: number, jobid: number, item) {  // VARIABLES COME FROM ONCLICK FUNCTION FROM THIS COMPONENT.HTML
    if (this.directionsDisplay != undefined || this.directionsDisplay != null) {
      this.directionsDisplay.setMap(null);
    }
    if (this.allroute_markers.length > 0) {
      for (let inst = 0; inst < this.allroute_markers.length; inst++) {
        this.allroute_markers[inst].setMap(null);
      }
      this.allroute_markers = [];
    }
    if (this.markers.length > 0) {
      for (let inst = 0; inst < this.markers.length; inst++) {
        this.markers[inst].setMap(null);
        this.directionsDisplay.setMap(null);
      }
    }
    if (this.path_his.length > 0) {
      for (var inst = 0; inst < this.path_his.length; inst++) {
        this.path_his[inst].setMap(null);
        this.pathline.setMap(null);
      }
      this.path_his = [];
      this.markers = [];
    }
    if (this.mqttarray.length != 0) {
      for (let inst = 0; inst < this.map_marker.length; inst++) {
        this.map_marker[inst].setMap(null);
      }
      for (let inst = 0; inst < this.flightPath.length; inst++) {
        this.flightPath[inst].setMap(null);
      }
      this.map_marker = [];
    }

    this.markersEmpty();
    this.clearAllMarkers();
    if (this.client != undefined) {
      this.client.disconnect();
      this.client = undefined;
    }

    this.id = jobid;
    this.i = i;
    this.bookingid = item.bookingId;
    if (jobid == 3 || jobid == 1) {
      if (jobid == 1) {
        this.driverVehicleShow = false;
      } else {
        this.driverVehicleShow = true;
      }
      if (item.bookingId != undefined) {
        this.getCustomerBookings1(item.bookingId, item.status, 2);
      }
    } else if (jobid == 2) {
      if (item.bookingId != undefined) {
        this.getCustomerBookings(item.bookingId, item.status, 1);
      }
    }
  }
  // Give Tip
  postTip(tip) {
    $("#appt_loader_parent").show();
    this._dispatcherHomeService.postTip({
      bookingId: this.pendingBookingId.toString(),
      tip: parseFloat(tip)
    }).subscribe((res) => {
      $("#appt_loader_parent").hide();
      $('#appt_loader_parent').hide();
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $("#appt_loader_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
        }
      })
  }
  // get bookings with callform 1
  getCustomerBookings(bookingId, status, callForm) {
    $("#appt_loader_parent").show();
    this.current_time = new Date();
    this.current_time_var = this.current_time.getFullYear() + '-' + ("0" + (this.current_time.getMonth() + 1)).slice(-2) + '-' + this.current_time.getDate();
    var start_date;
    var drop_date;
    if (this.picker_bool != true) {
      this.picker_date = this.current_time_var;
      start_date = "";
      drop_date = "";
    }
    else {
      this.picker_date = this.picker_date;
      start_date = this.picker_date;
      drop_date = this.drop_date;
    }
    this._dispatcherHomeService.getdata({
      bookingId: bookingId,
      callFrom: 1
    }).subscribe((res) => {
      if (res.data.invoice != undefined && res.data.invoice != undefined) {
        this.cardDeduct = res.data.invoice.paymentMethod.cardDeduct;
        this.tipEnable = res.data.invoice.tip.isTipEnable;
        this.tipType = res.data.invoice.tip.tipType;
        this.tipValues = res.data.invoice.tip.tipValues;
      }
      $('#appt_loader_parent').hide();
      this.getCustomerBookings1(bookingId, status, 2);
      this.liveStatus = res.data.status;
      this.driverMarker = res.data.driver;
      this.pickupMarker = res.data.pickup;
      this.dropMarker = res.data.drop;
      if (res.data.vehicle != undefined) {
        this.vehicle_icon = res.data.vehicle.mapIcon;
      }
      this.live_path_show(res.data);
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $("#appt_loader_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
        }
      });
  }
  // get bookings with callform 2
  getCustomerBookings1(bookingId, status, callForm) {
    $("#appt_loader_parent").show();
    this.current_time = new Date();
    this.current_time_var = this.current_time.getFullYear() + '-' + ("0" + (this.current_time.getMonth() + 1)).slice(-2) + '-' + this.current_time.getDate();
    var start_date;
    var drop_date;
    if (this.picker_bool != true) {
      this.picker_date = this.current_time_var;
      start_date = "";
      drop_date = "";
    }
    else {
      this.picker_date = this.picker_date;
      start_date = this.picker_date;
      drop_date = this.drop_date;
    }

    this._dispatcherHomeService.getdata({
      bookingId: bookingId,
      callFrom: 2
    }).subscribe((res) => {
      $('#appt_loader_parent').hide();
      this.passDetailsContent = res.data;
      this.notMinFee = this.passDetailsContent.receipt.baseFee + this.passDetailsContent.receipt.distanceFee + this.passDetailsContent.receipt.timeFee + this.passDetailsContent.receipt.waitingFee;
      if (res.data.dateAndTime != undefined) {

        if (res.data.dateAndTime.accepted != 0) {
          res.data.dateAndTime.accepted = moment(res.data.dateAndTime.accepted).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.onTheWay != 0) {
          res.data.dateAndTime.onTheWay = moment(res.data.dateAndTime.onTheWay).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.arrived != 0) {
          res.data.dateAndTime.arrived = moment(res.data.dateAndTime.arrived).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.created != 0) {
          res.data.dateAndTime.created = moment(res.data.dateAndTime.created).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.cancelled != 0) {
          res.data.dateAndTime.cancelled = moment(res.data.dateAndTime.cancelled).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.journeyComplete != 0) {
          res.data.dateAndTime.journeyComplete = moment(res.data.dateAndTime.journeyComplete).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.journeyStart != 0) {
          res.data.dateAndTime.journeyStart = moment(res.data.dateAndTime.journeyStart).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.unloaded != 0) {
          res.data.dateAndTime.unloaded = moment(res.data.dateAndTime.unloaded).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.expired != 0) {
          res.data.dateAndTime.expired = moment(res.data.dateAndTime.expired).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.loaded != 0) {
          res.data.dateAndTime.loaded = moment(res.data.dateAndTime.loaded).format("MMMM Do YYYY, h:mm:ss a");
        }
        if (res.data.dateAndTime.reachedDrop != 0) {
          res.data.dateAndTime.reachedDrop = moment(res.data.dateAndTime.reachedDrop).format("MMMM Do YYYY, h:mm:ss a");
        }
      }
      this.showgooglepath();
      if (status == 12) {
        this.live_path_show(this.passDetailsContent);
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $("#appt_loader_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $("#appt_loader_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $("#appt_loader_parent").hide();
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
        }
      });
  }
  // Get Wallet Details
  wallet() {
    this._dispatcherService.wallet({}).subscribe((res) => {
      this._cookie.setWalletDetails(res.data);
      this.currency = res.data.currencySymbol;
      $('#wallet_balance').text(res.data.walletBalance).trigger('change');
      this.showing_balance = this._cookie.getWalletDetails('walletBalance');
      this.walletEnable = Boolean(this._cookie.getWalletDetails('isEnabled'));
    });
  }

  // END OF UBER FOR ALL FUNCTIONS
}




// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/dispatcher/dispatcherhome/dispatcherhome.component.ts